var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Title'),_c('div',{staticClass:"api-wrapper"},[_c('div',{staticClass:"api-content"},[_vm._t("default")],2)]),_c('Left-Drawer',{ref:"drawerL"}),_c('Right-Drawer',{ref:"drawerR"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }